<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { removeAccessToken, localStorage } from '@/utils'
export default {
  name: 'App'
  // beforeCreate () {
  //   window.addEventListener('beforeunload', function () {
  //     localStorage.setItem('unflag', localStorage.getItem('flag'))
  //     localStorage.setItem('beforeunload', Date.now())
  //     localStorage.removeItem('flag')
  //   })

  //   window.addEventListener('load', function () {
  //     const beforeunload = Number(localStorage.getItem('beforeunload'))
  //     console.log(Date.now(), beforeunload, Date.now() - beforeunload)

  //     if (Date.now() - beforeunload < 1000) {
  //       localStorage.setItem('flag', localStorage.getItem('unflag'))
  //       localStorage.removeItem('unflag')
  //     }
  //   })
  // }
}
</script>

<style lang="postcss">
/* Module base
-------------------------------------------------- */
[class^='icon-'],
[class*=' icon-'] {
  line-height: inherit;
  font-size: 16px;
  text-align: center;
  vertical-align: top;
  display: inline-block;
}

html {
  height: 100%;
  color: #555;
  background-color: #f6f8f9;
  font-size: 14px;
}

html,
textarea,
input {
  font-family: -apple-system, 'PingFang SC', 'Microsoft YaHei', 'Hiragino Sans GB', 'SF UI Text',
    'Helvetica Neue', Arial, 'WenQuanYi Zen Hei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.5;
}

body {
  margin: 0;
  min-width: 1200px;

  &.full-screen {
    height: 100%;

    #app {
      height: 100%;
    }
  }
}

div,
p,
span,
strong,
a,
ul,
ol,
li,
i,
img,
h2,
h3,
h4,
h5,
form,
input,
textarea {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

ul,
ol,
li {
  list-style: none;
}

* {
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  vertical-align: top;
}

a {
  text-decoration: none;
  color: #666;
}

input[type='text'],
input[type='password'],
select,
textarea {
  height: 38px;
  border: 1px solid #d7dde4;
  padding: 5px;
  font-size: 13px;
  border-radius: 5px;

  &:hover {
    border-color: #bcbcbc;
  }

  &:focus {
    border-color: #2d8cf0;
  }
}

/* Module clearfix & float
-------------------------------------------------- */
.clearfix:after {
  display: table;
  box-sizing: border-box;
  content: ' ';
  clear: both;
}

.f-l {
  float: left;
}

.f-r {
  float: right;
}

/* Module flex
-------------------------------------------------- */
.flex {
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;

  .cell {
    -webkit-box-flex: 1;
    flex: 1;
    display: block;
    max-width: 100%;
    flex-basis: 0;
    min-width: 0; /* 必须加上min-width:0; 不然cell里如果使用了elis，则会溢出 */
  }

  &.column {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
  }

  &.item-c {
    -webkit-box-align: center;
    align-items: center;
  }

  &.jcc {
    -webkit-box-pack: center;
    justify-content: center;
  }

  &.jcsb {
    -webkit-box-pack: justify;
    justify-content: space-between;
  }
}

/* Module others
-------------------------------------------------- */
.mod-box {
  width: 1200px;
  margin: 0 auto;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
